export default "__VITE_ASSET__BI6m3M3Z__"